module.exports = __webpack_public_path__ + "img/carEnd.db8c995b.png";